<i18n>
{
    "ru": {
        
    }
}
</i18n>
<template>
    <div class="cat-filter-block"
        :data-opened="opened">
        <div v-if="title" 
            class="cat-filter-block__head"
            @click="toggle">
            {{ title }}
            <span v-if="counter"
                class="cat-filter-block__count"> 
                ({{ counter }})
            </span>

            <HelpButton v-if="tooltip"
                class="cat-filter-block__help"
                :content="tooltip" />
        </div>
        <div class="cat-filter-block__body">
            <slot name="block-body"></slot>
            <button-reset v-if="counter"
                @click.native="$emit('reset')"
                class="cat-filter-block__reset" />
        </div>
    </div>
</template>

<script>
import ButtonReset from '@/components/ui/buttons/ButtonReset';
import HelpButton from '@/components/ui/HelpButton';

export default {
    name: 'CatFilterBlock',
    components: {
        ButtonReset,
        HelpButton
    },
    props: {
        /**
         * ID фильтра
         * @type {String}
         */
        id: {
            type: String,
            default: null
        },
        /**
         * Название фильтра
         * @type {String}
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * Описание названия
         * @type {String}
         */
        tooltip: {
            type: String,
            default: ''
        },
        /**
         * Кол-во отмеченных
         * @type {Number|null}
         */
        counter: {
            type: [Number, null],
            default: null
        },
        /**
         * Является открытым
         * @type {Boolean}
         */
        isOpened: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opened: this.isOpened
        };  
    },
    methods: {
        toggle() {
            this.opened = !this.opened;
        }
    }
}
</script>

<style lang="less">
.cat-filter-block{
    border-bottom: rem(1) solid @color-gray-white;
    background: @color-white;

    &[data-opened="true"] {
        .cat-filter-block{
            &__head{
                &:after{
                    .rotate(180deg);
                }
            }
            &__body{
                display: block;
            }
        }
    }

    &__head{
        cursor: pointer;
        height: rem(56);
        line-height: rem(58);
        font-weight: 500;
        font-size: rem(15);
        .wi(icon-chevron-down, 14, 14, @ab: after);
        .noSelection;

        &:after{
            margin-top: rem(-7);
            top: 50%;
            background-size: contain;
            right: rem(3);
        }

        .hover({
            color: @color-violet;
        });
    }

    &__body{
        display: none;
        padding-bottom: rem(24);
    }

    &__count{
        color: @color-violet;
    }

    &__help{
        position: absolute;
        top: 0;
        margin-left: rem(6);
    }

    &__note{
        position: relative;
        margin-top: -10px;
        font-size: rem(13);
        color: @color-gray;
    }

    &__checkbox{
        margin-top: rem(23.5);

        &>label{
            padding-top: rem(2);
            padding-left: rem(30);
        }
    }

    &__rating-stars{
        --star-width: rem(17);
        --star-height: rem(14);
    }

    &__reset{
        margin-top: rem(24);
    }
}
</style>